import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { toastStore } from 'shared/ui'
import { RequestLoadData } from 'shared/api/lib'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { BillingApi } from 'entities/Billing'
import { RemoveSeatsUi } from 'entities/Seat/ui/RemoveSeats/ui/RemoveSeatsUi'

export class RemoveSeats {
  readonly modalId = nanoid()
  private _seats: number | null = 1

  constructor(readonly entities: IEntitiesStore, readonly parentModalId: string) {
    makeAutoObservable(this)
  }

  openModal = () => {
    modalStore.setHideModalId(this.parentModalId)
    modalStore.addModal({
      onClose: this.onCancel,
      id: this.modalId,
      title: 'Remove seats',
      pureContent: true,
      ModalContent: () => <RemoveSeatsUi store={this} />,
    })
  }

  onBack = () => {
    modalStore.removeModal(this.modalId)
    modalStore.removeHideModalId(this.parentModalId)
  }

  onCancel = () => {
    modalStore.removeModal(this.modalId)
    modalStore.removeHideModalId(this.parentModalId)
    modalStore.removeModal(this.parentModalId)
  }

  get seats() {
    return String(this._seats || '')
  }

  setSeats = (seats: string) => {
    this._seats = seats === '' ? null : Number(seats)
  }

  readonly requestRemoveSeatsInfoStatus = new RequestLoadData({
    requestCallback: async () => {
      if (!this._seats) return

      const { data } = await BillingApi.removeSeats(this._seats)
      this.entities.subscriptionStore.setSeats(data)
      toastStore.add({
        type: 'success',
        title: `${this._seats} seat${this._seats > 1 ? 's' : ''} removed`,
      })
      this.onCancel()
    },
  })

  onRemove = async () => {
    return this.requestRemoveSeatsInfoStatus.loadData()
  }
}
